/**
 * Coure.RateBillingManagement.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateRateAndRateDetailDto } from '../model/createRateAndRateDetailDto';
import { ProblemDetails } from '../model/problemDetails';
import { Rate } from '../model/rate';
import { RateClientResourceRateDto } from '../model/rateClientResourceRateDto';
import { RateCreateDto } from '../model/rateCreateDto';
import { RateUpdateDto } from '../model/rateUpdateDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RatesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesCreatePost(body?: RateCreateDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRatesCreatePost(body?: RateCreateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRatesCreatePost(body?: RateCreateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRatesCreatePost(body?: RateCreateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Rates/Create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesCreateRateAndRateDetailsPost(body?: CreateRateAndRateDetailDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRatesCreateRateAndRateDetailsPost(body?: CreateRateAndRateDetailDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRatesCreateRateAndRateDetailsPost(body?: CreateRateAndRateDetailDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRatesCreateRateAndRateDetailsPost(body?: CreateRateAndRateDetailDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Rates/CreateRateAndRateDetails`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesDeleteDelete(rateId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRatesDeleteDelete(rateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRatesDeleteDelete(rateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRatesDeleteDelete(rateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/Rates/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesGetAllForMerchantGet(merchantId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Rate>>;
    public apiRatesGetAllForMerchantGet(merchantId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Rate>>>;
    public apiRatesGetAllForMerchantGet(merchantId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Rate>>>;
    public apiRatesGetAllForMerchantGet(merchantId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantId !== undefined && merchantId !== null) {
            queryParameters = queryParameters.set('merchantId', <any>merchantId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Rate>>('get',`${this.basePath}/api/Rates/GetAllForMerchant`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Rate>>;
    public apiRatesGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Rate>>>;
    public apiRatesGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Rate>>>;
    public apiRatesGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Rate>>('get',`${this.basePath}/api/Rates/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param operationCount 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet(clientResourceId: string, operationCount: number, observe?: 'body', reportProgress?: boolean): Observable<RateClientResourceRateDto>;
    public apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet(clientResourceId: string, operationCount: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RateClientResourceRateDto>>;
    public apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet(clientResourceId: string, operationCount: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RateClientResourceRateDto>>;
    public apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet(clientResourceId: string, operationCount: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clientResourceId === null || clientResourceId === undefined) {
            throw new Error('Required parameter clientResourceId was null or undefined when calling apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet.');
        }

        if (operationCount === null || operationCount === undefined) {
            throw new Error('Required parameter operationCount was null or undefined when calling apiRatesGetByClientResourceIdAndOperationCountClientResourceIdOperationCountGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RateClientResourceRateDto>('get',`${this.basePath}/api/Rates/GetByClientResourceIdAndOperationCount/${encodeURIComponent(String(clientResourceId))}/${encodeURIComponent(String(operationCount))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesGetRateByIdGet(rateId?: string, observe?: 'body', reportProgress?: boolean): Observable<Rate>;
    public apiRatesGetRateByIdGet(rateId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Rate>>;
    public apiRatesGetRateByIdGet(rateId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Rate>>;
    public apiRatesGetRateByIdGet(rateId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rateId !== undefined && rateId !== null) {
            queryParameters = queryParameters.set('rateId', <any>rateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Rate>('get',`${this.basePath}/api/Rates/GetRateById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRatesUpdatePost(body?: RateUpdateDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiRatesUpdatePost(body?: RateUpdateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiRatesUpdatePost(body?: RateUpdateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiRatesUpdatePost(body?: RateUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Rates/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
